module.exports = __webpack_public_path__ + "static/img/n-clock-finish.0cba34e7.png";